import { Component, computed, HostBinding, input, output } from '@angular/core';
import { ArtIconComponent } from '../art-icon/art-icon.component';
import { NgStyle } from '@angular/common';
import { DesignSystemModule } from '@compeople-shared/design-system-angular';

@Component({
  selector: 'art-button',
  imports: [ArtIconComponent, NgStyle, DesignSystemModule],
  templateUrl: './art-button.component.html',
  styleUrl: './art-button.component.scss',
})
export class ArtButtonComponent {
  type = input<'button' | 'submit'>('button');
  label = input<string>();
  icon = input<string>();
  iconPlacement = input<'icon-before' | 'icon-after'>('icon-before');
  asset = input<string>();
  disabled = input<boolean>();
  display = input<'inline' | 'block'>('inline');
  shape = input<'primary' | 'secondary' | 'link'>('primary');
  finalShape = computed(() => (this.asset() ? 'link' : this.shape()));

  clickedButton = output<MouseEvent>();

  @HostBinding('class') get classes() {
    return [this.display(), this.iconPlacement()].join(' ');
  }
}
